<style scoped>
.user-image {
    width: 100px;
    height: 100px;
}
</style>

<template>
    <ToolboxWindow v-model="dialog" :close="true" @close="dialog = false" :initialX="showAtX" :initialY="showAtY" :persistent="true" maxWidth="275px">
        <v-card v-if="user" class="pa-4">
            <div class="d-flex align-center">
                <v-avatar :size="40">
                    <img :src="'/api/memberapi/image/member/get?size=50x50&id=' + user.id" class="user-image" />
                </v-avatar>
                <div class="font-weight-bold ml-4">{{user.name}}</div>
            </div>
            <hr class="mt-2"/>
            <div class="d-flex flex-column">
                <div class="my-2 d-flex flex-row" v-if="user.mail">
                    <v-icon>mdi-email-edit-outline</v-icon>
                    <div class="ml-2 text-truncate"><a :href="'mailto:' + user.mail">{{user.mail}}</a></div>
                </div>
                <div class="my-2 d-flex flex-row" v-if="user.phone">
                    <v-icon>mdi-phone-forward-outline</v-icon>
                    <div class="ml-2 text-truncate"><a :href="'tel:' + user.phone">{{user.phone}}</a></div>
                </div>
            </div>
            <template v-if="match">
                <hr class="mb-2"/>
                {{$translate('Match status')}}
                <v-row>
                    <v-col cols="6">
                        <v-btn color="primary" @click="togglePresence" :loading="settingPresence">
                            <v-icon>{{ isPresent ? 'mdi-checkbox-marked-outline' : 'mdi-checkbox-blank-outline' }}</v-icon>
                            {{$translate(isPresent ? 'Present' : 'Not present')}}
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            v-model="shirtNumber"
                            :label="$translate('Shirt number')"
                            type="text"
                            hide-details
                            single-line dense
                            :append-icon="savedShirtNumber ? 'mdi-check' : undefined"
                            :icon-color="savedShirtNumber ? 'success' : 'primary'"
                            @input="updateShirtNumber"
                            @keypress="isNumberKey"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </template>
        </v-card>
    </ToolboxWindow>
</template>

<script>
import ToolboxWindow from '../ToolboxWindow.vue'
export default {
    name: 'zoezi-teamsport-player-details-dialog',

    props: {
        value: {
            type: Boolean,
            default: false
        },
        user: {
            type: Object
        },
        showAtX: {
            type: Number,
        },
        showAtY: {
            type: Number,
        },
        match: {
            type: Object
        },
        teamId: {
            type: Number
        },
        attendance: {
            type: Array
        }
    },

    watch: {
        user: {
            immediate: true,
            handler() {
                this.shirtNumber = this.user?.shirt_number;
            }
        }
    },

    components: {
        ToolboxWindow
    },

    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        isPresent() {
            return this.attendance?.find(x => x.user.id == this.user.id)?.present;
        }
    },

    data: () => ({
        shirtNumber: '',
        savedShirtNumber: false,
        debounceTimeout: null,
        settingPresence: false
    }),

    methods: {
        isNumberKey(event) {
            // Check if the key pressed is a numeric key
            if (/\D/g.test(event.key)) {
                event.preventDefault();
            }
        },
        updateShirtNumber(event) {
            // Remove all non-numeric characters in case of copy-paste
            this.shirtNumber = event.replace(/\D/g, '');

            if (!this.shirtNumber) {
                return;
            }

            clearTimeout(this.debounceTimeout);
            this.iconColor = '';
            this.debounceTimeout = setTimeout(() => {
                this.setShirtNumber();
            }, 500);
        },
        possiblyShowError(response) {
            if (!response.ok) {
                response.json().then(data => {
                    this.$store.commit('showErrorDialog', { title: this.$translate('Error'), text: `${this.$translate('Something went wrong')}. ${this.$translate(data?.message)}`});
                });
            }
        },
        togglePresence() {
            const attendance = this.attendance?.find(x => x.user.id == this.user.id);
            const data = {
                id: attendance.id,
                present: !attendance.present
            };
            this.settingPresence = true;
            this.$api.post('/api/memberapi/teamsport/attendance/set', data).then(response => {
                if (response.ok) {
                    this.$emit('updateAttendance', this.teamId, data);
                }
                this.possiblyShowError(response);
                this.settingPresence = false;
            });
        },
        setShirtNumber() {
            const shirts = this.match.shirt_numbers?.filter(x => x.team == this.teamId && x.user != this.user.id).map(x => {
                return { shirt: x.shirt, user_id: x.user }
            }) || [];
            const data = {
                match_id: this.match.id,
                team_id: this.teamId,
                shirts: [...shirts, { shirt: this.shirtNumber, user_id: this.user.id }]
            };

            this.$api.post('/api/teamsport/match/set_shirt_numbers', data).then(response => {
                if (response.ok) {
                    this.savedShirtNumber = true;
                    setTimeout(() => this.savedShirtNumber = false, 3000);
                }
                this.possiblyShowError(response);
            })
        }
    }
}
</script>
